import React from "react";

interface ClosedEyeIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const ClosedEyeIcon: React.FC<ClosedEyeIconProps> = ({ width = 16, className, height = 16, color = "#595A61" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M4.62917 4.3324C5.62192 3.68731 6.77223 3.20801 8 3.20801C10.79 3.20801 13.18 5.68304 14.23 6.95431C14.3958 7.16103 14.4876 7.4296 14.4876 7.70807C14.4876 7.98653 14.3958 8.2551 14.23 8.46183C13.6512 9.16258 12.6653 10.2291 11.4296 11.0452M9.5 11.9777C9.01762 12.1236 8.51564 12.2081 8 12.2081C5.21 12.2081 2.82 9.73309 1.77 8.46183C1.60416 8.2551 1.51236 7.98653 1.51236 7.70807C1.51236 7.4296 1.60416 7.16103 1.77 6.95431C2.10267 6.55153 2.56985 6.02792 3.14165 5.50048"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.41421 9.12204C10.1953 8.34099 10.1953 7.07466 9.41421 6.29361C8.63316 5.51256 7.36684 5.51256 6.58579 6.29361"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.5 14.208L1.5 1.20801" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ClosedEyeIcon;
